export default __webpack_public_path__ + "static/media/construction.29a57ead.svg";